<div class="custom-status-panel">
  <p-dropdown
    class="page-size-dropdown"
    [options]="pageSizes"
    [(ngModel)]="selectedPageSize"
    (onChange)="onPageSizeChange($event)"
    optionLabel="label"
    optionValue="value"
    appendTo="body"
  ></p-dropdown>

  <span class="record-count">
    {{ recordRangeLabel }}
  </span>

  <div class="page-controls">
    <p-button
      icon="pi pi-step-backward"
      (click)="goToFirstPage()"
      class="p-button-xs page-control-first"
      styleClass="p-button-rounded p-button-text"
    ></p-button>
    <p-button
      icon="pi pi-caret-left"
      (click)="goToPrevPage()"
      class="p-button-xs"
      styleClass="p-button-rounded p-button-text"
    ></p-button>
    <span class="page-number">{{ params.api.paginationGetCurrentPage() + 1 }}/{{ params.api.paginationGetTotalPages() }}</span>
    <p-button
      icon="pi pi-caret-right"
      (click)="goToNextPageDebounced()"
      class="p-button-xs"
      styleClass="p-button-rounded p-button-text"
    ></p-button>
    <p-button
      icon="pi pi-step-forward"
      (click)="goToLastPage()"
      class="p-button-xs page-control-last"
      styleClass="p-button-rounded p-button-text"
    ></p-button>
  </div>
</div>
